import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IonicModule} from "@ionic/angular";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-map-legend',
  templateUrl: './map-legend.component.html',
  styleUrls: ['./map-legend.component.scss'],
  imports: [
    IonicModule,
    TranslatePipe,
  ],
  standalone: true
})
export class MapLegendComponent {
  @Input() isOpen: boolean = false;
  @Input() isMobile: boolean = false;
  @Output() close: EventEmitter<any> = new EventEmitter();

  onClose() {
    this.isOpen = false;
    this.close.emit();
  }

}
